jQuery(document).ready(function($) {
    $(document).on('click','[data-toggle="menu"]',function(e) {
        e.preventDefault();
        var $menu = $(this).closest('.menu');
        if ($menu.hasClass('menu-animating'))
        {
            $menu.toggleClass('menu-open').stop();
            $menu.addClass('menu-animating');
        }
        else
            $menu.addClass('menu-animating');
        if (!$menu.hasClass('menu-open'))
        {
            $('body').addClass('menu-is-open');
            $menu.animate({
                top: 0
            }, {
                duration: 1000,
                // easing: 'easeOutBounce',
                easing: 'easeOutSine',
                complete: function() {
                    $menu.addClass('menu-open');
                    $menu.removeClass('menu-animating');
                }
            });
        }
        else {
            console.log('close menu');
            $menu.animate({
                top: '-100vh'
            }, 1000, 'easeOutSine',function() {
                $menu.removeClass('menu-open');
                $menu.removeClass('menu-animating');
                $('body').removeClass('menu-is-open');
            });
        }
    });
});
